import { render, staticRenderFns } from "./lineCard.vue?vue&type=template&id=2c3a1b54&scoped=true"
import script from "./lineCard.vue?vue&type=script&lang=js"
export * from "./lineCard.vue?vue&type=script&lang=js"
import style0 from "./lineCard.vue?vue&type=style&index=0&id=2c3a1b54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a1b54",
  null
  
)

export default component.exports